import { createFeature, createReducer, on } from '@ngrx/store';
import { SettingsAiRuntime } from '../../../../shared/services/settings/settings.service';
import { settingsAiActions } from './settings-ai.actions';

export const SETTINGS_AI_FEATURE_KEY = 'settingsAi';

export type SettingsAiStatus = 'idle' | 'loading' | 'loaded' | 'error';
export type SettingsAiMutationStatus = 'idle' | 'pending';

export interface SettingsAiState {
  settings: SettingsAiRuntime | null;
  status: SettingsAiStatus;
  mutationStatus: SettingsAiMutationStatus;
  error: string | null;
}

export const initialSettingsAiState: SettingsAiState = {
  settings: null,
  status: 'idle',
  mutationStatus: 'idle',
  error: null,
};

export const settingsAiReducer = createReducer(
  initialSettingsAiState,
  on(settingsAiActions.loadSettingsAi, state => ({
    ...state,
    status: 'loading',
    error: null,
  })),
  on(settingsAiActions.loadSettingsAiSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsAiActions.loadSettingsAiFailure, (state, { error }) => ({
    ...state,
    status: 'error',
    mutationStatus: 'idle',
    error,
  })),
  on(settingsAiActions.updateSettingsAi, state => ({
    ...state,
    mutationStatus: 'pending',
    error: null,
  })),
  on(settingsAiActions.updateSettingsAiSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsAiActions.updateSettingsAiFailure, (state, { error }) => ({
    ...state,
    mutationStatus: 'idle',
    error,
  })),
);

export const settingsAiFeature = createFeature({
  name: SETTINGS_AI_FEATURE_KEY,
  reducer: settingsAiReducer,
});
